module.exports = __webpack_public_path__ + "img/img_lianxiwomen_toutu@3x.6760765b.png";